import { useState } from "react";
import api from "@/lib/api";

export const MAINT_KEY = "lira_maintenance_unlocked";

export const MaintenanceScreen = ({ logo, onUnlock }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/maintenance/unlock", { code });
      localStorage.setItem(MAINT_KEY, "1");
      onUnlock();
    } catch {
      setError("Invalid access code.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-[#F5EEDC] flex flex-col items-center justify-center px-6 text-center" data-testid="maintenance-screen">
      <img src={logo || "/lira-logo.png"} alt="LIRA" className="h-24 md:h-32 w-auto object-contain mb-10 mix-blend-multiply" data-testid="maintenance-logo" />
      <p className="text-red-600 text-lg md:text-2xl font-serif max-w-xl" data-testid="maintenance-message">
        Working on errors with the website, We will be back soon!
      </p>
      <form onSubmit={submit} className="mt-14 flex flex-col items-center gap-2" data-testid="maintenance-code-form">
        <div className="flex gap-2">
          <input type="password" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Access code"
            className="border border-[#d8ccb0] bg-transparent rounded-sm px-3 py-2 text-sm outline-none focus:border-[#1A1A1A] w-44"
            data-testid="maintenance-code-input" />
          <button type="submit" disabled={busy || !code} className="bg-[#1A1A1A] text-white text-xs uppercase tracking-[0.2em] px-4 rounded-sm disabled:opacity-50"
            data-testid="maintenance-code-submit">
            Enter
          </button>
        </div>
        {error && <p className="text-xs text-red-600" data-testid="maintenance-code-error">{error}</p>}
      </form>
    </div>
  );
};
